<template>
    <b-row class="mb-3">
        <b-col cols="3">
            <label :for="name">
                {{label}}
            </label>
        </b-col>
        <b-col cols="9">
            <b-form-textarea :rows="3" :max-rows="6" v-bind:value="value" v-on:input="$emit('input', $event)" :id="name" type="text"></b-form-textarea>
        </b-col>
    </b-row>
</template>

<script>
export default {
  name: "rdkm-text-area",
  props: ["value", "label", "name"]
};
</script>
